var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmptystar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7281_7888)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.2715 8.80078L28.4639 10.0494C29.9331 10.2721 30.5219 12.1646 29.4562 13.2486L23.5284 19.2826L24.9293 27.8074C25.1286 29.0256 24.1984 29.9988 23.1573 29.9988C22.8825 29.9988 22.5993 29.9309 22.3273 29.7814L14.9986 25.7561L7.66928 29.7803C7.3967 29.9314 7.11293 30 6.837 30C5.79708 30 4.86853 29.0232 5.06779 27.8057L6.4704 19.2814L0.543719 13.2463C-0.521393 12.1623 0.0674133 10.2703 1.53663 10.0477L9.72954 8.80019L13.3917 1.04355C13.7219 0.345703 14.3594 0 14.9974 0C15.6394 0 16.2814 0.350391 16.6105 1.04355L20.2715 8.80078Z",
    fill: "#E1E1E1"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7281_7888"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptystar);
export default __webpack_public_path__ + "static/media/emptystar.9fec817516671986e4d6281f560f168f.svg";
export { ForwardRef as ReactComponent };